import * as React from 'react';
import { DatePicker as SitDatePicker } from '../../../components/DatePicker/DatePicker';

interface Props {
  onScheduleDateChange: (event: any) => void;
  error?: string;
  placement?: 'top' | 'bottom';
  hideLabel?: boolean;
  autoFocus?: boolean;
}

export const ScheduleSendingForm: React.FunctionComponent<Props> = props => {
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!props.autoFocus) return;

    const frame = window.requestAnimationFrame(() => {
      const container = containerRef.current;
      if (!container) return;

      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const focusTarget = container.querySelector<HTMLElement>('button, input, [tabindex]:not([tabindex="-1"])');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [props.autoFocus]);

  return (
    <div className="gmScheduleField" ref={containerRef}>
      <SitDatePicker
        label={props.hideLabel ? undefined : 'Schedule date and time'}
        mode="datetime"
        value={selectedDate}
        onChange={(date: Date | null) => {
          setSelectedDate(date);
          props.onScheduleDateChange({
            target: {
              value: date ? date.toISOString() : ''
            }
          });
        }}
        min={new Date()}
        minuteStep={5}
        placeholder="Select date and time"
        required
        error={props.error}
        placement={props.placement}
        clearable
        className="gmScheduleDateTimePicker"
      />
    </div>
  );
};
